import { PromoCodeSectionProps } from '../../types';
import { CheckoutSection } from './CheckoutSection';

/**
 * Promo code selection section for checkout.
 * Displays available promo codes and shows success message when one is applied.
 */
export function PromoCodeSection({
  promoCodes,
  selectedPromoCode,
  onPromoCodeChange,
}: PromoCodeSectionProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const promo = promoCodes.find((p) => p.id === Number(e.target.value));
    onPromoCodeChange(promo);
  };

  return (
    <CheckoutSection title="Promo Code">
      <div className="space-y-3">
        <select
          className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
          value={selectedPromoCode?.id || ''}
          onChange={handleChange}
        >
          <option value="">Select a promo code (optional)</option>
          {promoCodes
            .filter((p) => p.active && p.id !== null)
            .map((promo) => (
              <option key={promo.id} value={promo.id!}>
                {promo.promo} {promo.memo ? `- ${promo.memo}` : ''}
              </option>
            ))}
        </select>
        {selectedPromoCode && (
          <div className="flex items-center text-sm text-green-600 bg-green-50 px-3 py-2 rounded-lg">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            Promo code applied: {selectedPromoCode.promo}
          </div>
        )}
      </div>
    </CheckoutSection>
  );
}
